<div *ngIf="isImpersonated$ | async" class="impersonation-banner">
  You are in impersonation mode: {{ userService.getUserSnapshot()?.firstName }} {{ userService.getUserSnapshot()?.lastName }} ({{ userService.getUserSnapshot()?.email }}).
  <a class="btn btn-link font-weight-600" (click)="endImpersonation()">End impersonation →</a>
</div>
